import { Tooltip as TooltipPrimitive, styled } from '@streamelements/frontend-ui';
import { ComponentProps, forwardRef } from 'react';

const { Root, Trigger, Content: TooltipContent } = TooltipPrimitive;

const StyledContent = styled(TooltipContent, {
  display: 'flex',
  justifyContent: 'center',
});

const Content = forwardRef<HTMLDivElement, ComponentProps<typeof TooltipContent>>((props, ref) => (
  <StyledContent {...props} sideOffset={props.sideOffset ?? 4} ref={ref} />
));

export { Root as Tooltip, Trigger as TooltipTrigger, Content as TooltipContent };
